import React, { Component } from 'react';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import { Cookies } from 'react-cookie';
import {Element, scroller} from 'react-scroll';
import _ from 'lodash';
import {Helmet} from 'react-helmet';

import getOpenEnrollmentDates from '../../helpers/openEnrollment';
import getMedicareFaqs from '../../helpers/medicareFaqs';
import VimeoEmbed from '../../components/VimeoEmbed/VimeoEmbed';
import medicare101Thumb from '../../assets/video/medicare-101-thumb.jpg';
import LearnMore from '../../components/Forms/LearnMore';
import SendQuote from '../../components/Forms/SendQuote';
import ReasonsResults from '../../components/Reasons/ReasonsResults';
// import iconChecks from '../../assets/svg/icon-checks.svg';
import cdphpLogo from '../../assets/logo.svg';
// import CustomerConnect from '../../components/CustomerConnect/CustomerConnect';
import Accordion from '../../components/Accordion/Accordion';
import ScrollButton from '../../components/Header/ScrollButton';
// import medicareRating from '../../assets/svg/icon-medicare-rating-sm.svg';
// import medicareRatingPPO from '../../assets/svg/icon-medicare-ppo.svg';
// import medicareRatingHMO from '../../assets/svg/icon-medicare-hmo.svg';

import * as ResultHelpers from '../../helpers/results';
import { encodeUrl } from '../../helpers/quiz';
import * as RouteHelpers from '../../helpers/routes';

class ResultsMedicareWesternNY extends Component {
  state = {
    fieldValues: {},
    result: {},
    plans: [],
    selectedPlan: [],
    loading: true,
    url: `${process.env.REACT_APP_API_URL}/plans/medicare-compare`,
    formResults: this.props.quiz.fieldValues,
    location: this.props.quiz.location,
    showModal: false,
    mounted: false,
    headerHeight: 100,
    animateChangePrice: false,
    trackOnce: true
  };

  componentDidMount () {
    const p = _.clone(this.props);
    const cookies = new Cookies();

    if (cookies.get('CDPHP_myResults') && this.props.showResults) { // Check for cookie
      this.setState({ formResults: cookies.get('CDPHP_myResults') });
    }

    if (p.route !== 'quote') {
      const resultType = p.quiz.fieldValues.Location.loc.IsWesternNY ? 'ResultsMedicareWesternNY' : 'ResultsMedicare';
      const fieldValues = _.merge({}, p.quiz.fieldValues, {'ResultsType': resultType});
      const resultString = encodeUrl(fieldValues);
      cookies.set('CDPHP_quoteString', resultString, { path: '/' });
      RouteHelpers.history.push('/quote/' + resultString);
    } else if (Object.keys(p.rest.quote).length === 0) {
      p.updateHeaderPhone('585-895-7733 | TTY: 711');
      p.updateHeaderHours(['M-F, 8 a.m. – 8 p.m.', <sup key='icon'>‡</sup>]);
      p.updateTopBanner(this.checkDate());
      p.toggleInQuiz(false);
      p.toggleInResults(true);
      p.updateResultsFooter(true, {
        'medicare': 'true',
        'medicareHours': 'true'
      });
      p.updateResultsRatings(true, {
        'medicare': 'true'
      });
      p.updateHeaderScroller(
        <ScrollButton
          text='Contact Me'
          scrollName='learnForm'
          scrollOpts={{
            duration: 800,
            delay: 0,
            smooth: 'easeInOutQuart',
            offset: -200
          }}
        />
      );
      this.props.reducer({fieldValues: p.quiz.fieldValues, url: 'medicare-compare'});
      // this.getHeaderHeight(document.querySelector('#template > article > header').scrollHeight + 200);
    }
  }

  static getDerivedStateFromProps (props, state) {
    const p = _.clone(props);
    const {rest, quiz} = p;
    const {fieldValues} = quiz;

    if (_.isObject(rest.quote) && Object.keys(rest.quote).length) {
      // set state once we have data from the server on the selected plan:

      const pOM = _.clone(rest.quote.planOrderMax);
      const pOP = _.clone(rest.quote.planOrderPremium);

      const newMaxOrder = pOM.sort((a, b) => (
        a.OopMaxInNetwork < b.OopMaxInNetwork ? -1 :
          a.OopMaxInNetwork > b.OopMaxInNetwork ? 1 : 0
      ));

      const newPremiumOrder = pOP.sort((a, b) => (
        a.Premium < b.Premium ? -1 :
          a.Premium > b.Premium ? 1 : 0
      ));

      const result = rest.quote.selectedPlan;
      const planOrderPremium = newPremiumOrder;
      const planOrderMax = newMaxOrder;
      let {lastSelectedPlanId} = _.clone(state);
      let additionalDays = (Number(result.InitialDaysCountInNetwork) + 1);
      let monthlyPremium = null;
      let annualDeductible = null;
      let oopmax = null;
      let oopmaxOON = null;
      let lowestPremium = null;
      let highestPremium = null;
      let lowestMax = null;
      let highestMax = null;
      let monthlyDollars = '';
      let monthlyCents = '';
      let oopMaxAmount;
      // let oopMaxAmountOON;
      let OopOon = null;

      if (!_.isUndefined(planOrderPremium) && _.isObject(planOrderPremium[0]) &&
        planOrderPremium[0].hasOwnProperty('Premium')
      ) {
        monthlyPremium = result.Premium;
        oopmax = result.OopMaxInNetwork;
        oopmaxOON = result.OopMaxOutOfNetwork;
        lowestPremium = planOrderPremium[0].Premium;
        highestPremium = planOrderPremium[planOrderPremium.length - 1].Premium.toFixed(2);
        lowestMax = planOrderMax[0].OopMaxInNetwork;
        highestMax = planOrderMax[planOrderMax.length - 1].OopMaxInNetwork;
      }

      if (!_.isUndefined(monthlyPremium) && !_.isNull(monthlyPremium)) {
        const monthlyPremiumString = monthlyPremium.toFixed(2).toString();
        monthlyDollars = monthlyPremiumString.slice(0, -3);
        monthlyCents = monthlyPremiumString.slice(-3);
      }

      oopMaxAmount = oopmax ? ResultHelpers.numberWithCommas(oopmax) : '';
      // oopMaxAmountOON = oopmaxOON ? ResultHelpers.numberWithCommas(oopmaxOON) : '0';
      lowestPremium = (!_.isUndefined(lowestPremium)) ? ResultHelpers.numberWithCommas(Math.round(lowestPremium)) : '';
      highestPremium = highestPremium ? ResultHelpers.numberWithCommas(Math.round(highestPremium)) : '';
      lowestMax = lowestMax ? ResultHelpers.numberWithCommas(lowestMax) : '0';
      highestMax = highestMax ? ResultHelpers.numberWithCommas(highestMax) : '';

      if (lastSelectedPlanId !== rest.quote.SelectedPlanId) {
        if (state.trackOnce === true) {
          ResultHelpers.sendAnalyticsOnQuote(fieldValues, rest);
        }

        const headerPremium = (
          <h5 key={monthlyDollars + monthlyCents} className={'price'}>
            <strong key={monthlyDollars}>
              ${ResultHelpers.numberWithCommas(monthlyDollars)}<sup key={monthlyCents}
              >{monthlyCents}</sup></strong> /Month</h5>
        );
        lastSelectedPlanId = rest.quote.SelectedPlanId;
        props.updateHeaderPremium(headerPremium);
      }

      // Send Location Through
      const cookies = new Cookies();
      let Loc = state.location;
      if (cookies.get('CDPHP_myResults')) {
        Loc = cookies.get('CDPHP_myResults').Location;
      }

      // if (result.PlanType.indexOf('HMO') <= 0) {
      //   OopOon = ('for services you receive from in-network providers (or $' + oopMaxAmountOON + ' for services received from any provider)');
      // } else {
      //   OopOon = 'toward your medical bills';
      // }

      return {
        lastSelectedPlanId,
        plans: rest.quote.Plans,
        selectedPlan: rest.quote.selectedPlan,
        selectedPlanID: rest.quote.SelectedPlanId,
        loading: false,
        fieldValues,
        planOrderPremium: newPremiumOrder,
        planOrderMax: newMaxOrder,
        monthlyPremium,
        annualDeductible,
        oopmax,
        lowestPremium,
        highestPremium,
        lowestMax,
        highestMax,
        monthlyDollars,
        monthlyCents,
        oopMaxAmount,
        oopmaxOON,
        OopOon,
        additionalDays,
        Loc,
        trackOnce: false
      };
    }

    return null; // if no state mutations are required at this time
  }

  componentWillUnmount () {
    this.setState({mounted: false});
  }

  // Create Cookie Here
  setCookie = (data) => {
    const cookies = new Cookies();
    cookies.set('CDPHP_myResults', data, { path: '/' });
  };

  getHeaderHeight = (height) => {
    this.setState({headerHeight: height});
  };

  // Medicare Enrollment
  checkDate = () => {
    return getOpenEnrollmentDates();
  }

  scrollTo () {
    scroller.scrollTo('learnForm', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: -200
    });
  }

  showQuoteOverlay = () => {
    this.setState({ showModal: true });
  }

  closeModal = () => {
    this.setState({ showModal: false });
  }

  render () {
    const s = _.clone(this.state);
    const result = s.selectedPlan;
    const {
      monthlyDollars,
      monthlyCents,
      fieldValues,
      Loc
    } = s;

    let loading;
    if (this.state.loading) {
      loading = 'loading';
    }

    // const showModal = this.state.showModal ? 'modal-open' : '';

    if (loading) {
      return <div className={'dark ' + loading} />;
    }

    // Move this to State
    let secondPlan;
    if (s.selectedPlanID === 'Zero') {
      secondPlan = s.plans[2];
    }
    if (s.selectedPlanID === 'Value') {
      secondPlan = s.plans[1];
    }
    if (s.selectedPlanID === 'Vital') {
      secondPlan = s.plans[4];
    }
    if (s.selectedPlanID === 'Complete') {
      secondPlan = s.plans[3];
    }

    let secondPlanDollars = '';
    let secondPlanCents = '';

    if (!_.isUndefined(secondPlan.Premium) && !_.isNull(secondPlan.Premium)) {
      const secondPremiumString = secondPlan.Premium.toFixed(2).toString();
      secondPlanDollars = secondPremiumString.slice(0, -3);
      secondPlanCents = secondPremiumString.slice(-3);
    }

    const accordionData = getMedicareFaqs({ planType: 'ppo' });

    return (
      <div className={'dark ' + loading}>
        <Helmet>
          <title>Your CDPHP Medicare Plan Quote</title>
        </Helmet>
        <article id='medicareCompare' className='nopad'>

          <section id='intro'>
            <div className='wrap'>
              <h1>We have just the Medicare Advantage<br /> plans for you, starting at $0!</h1>
              <h3>We recommend the <strong>{result.PlanName}</strong> Medicare {result.PlanType} plan.</h3>
              <button onClick={this.showQuoteOverlay} className='saveQuoteBtn btn alt'>Save My Quote</button>
            </div>
          </section>

          <section>
            <div className='wrap sm'>
              <div className='callout'>
                <div className='calloutContent'>
                  <p>Medicare Advantage plans cover more than Original Medicare, protecting you from unexpected&nbsp;costs.</p>
                  <p className='download'><span><strong>Want More?</strong> <a href='/pdf/CDPHP_2026_Medicare_Rochester_Plan_Options_Brochure.pdf' target='_blank' rel='noopener noreferrer'>Download a comparison of all our&nbsp;plans</a>.</span></p>
                </div>
                <VimeoEmbed videoId='1215229413' hash='bd848bae19' title='CDPHP Medicare 101'
                  thumbnail={medicare101Thumb} popover />
              </div>
            </div>
          </section>

          <section>
            <div className='wrap sm'>
              <div className='results medicare container'>
                <div className='table'>
                  <table>
                    <thead>
                      <tr className='topper'>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td><span>Recommended</span></td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr className='heading'>
                        <th className='item'>
                          <p className='note'><strong>Note:</strong> Original Medicare is required for any Medicare Advantage Plan</p>
                        </th>
                        <th>
                          <div className='card medicare'>
                            <h4>Original Medicare <span>Parts A &amp; B</span></h4>
                          </div>
                        </th>
                        <th>
                          <div className='card'>
                            <img src={cdphpLogo} alt='CDPHP | Capital District Physicians&rsquo; Health Plan' />
                            <h4>{result.PlanName} ({result.ShortPlanType})</h4>
                          </div>
                        </th>
                        <th>
                          <div className='card'>
                            <img src={cdphpLogo} alt='CDPHP | Capital District Physicians&rsquo; Health Plan' />
                            <h4>{secondPlan.PlanName} ({secondPlan.ShortPlanType})</h4>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className='subhead'>
                        <td className='item'>&nbsp;</td>
                        <td className='med'><h6><strong>Original Medicare</strong></h6><strong>$185<sup>.00</sup></strong><Tooltip html={(<span className='originalMedicare'>Most people pay the standard Part B monthly premium amount ($185.00 in 2025). Visit <a href='https://www.medicare.gov/basics/costs' target='_blank' rel='noopener noreferrer'>Medicare.gov</a> to learn more.</span>)} arrow='true' interactive='true'><span className='helpTip'>Estimated Monthly Cost</span></Tooltip></td>
                        <td className='hmo'><h6><strong>CDPHP {result.PlanName} ({result.ShortPlanType})</strong><span>Recommended</span></h6><strong>${monthlyDollars}<sup>{monthlyCents}</sup></strong> <span>Monthly Cost</span></td>
                        <td className='ppo'><h6><strong>CDPHP {secondPlan.PlanName} ({secondPlan.ShortPlanType})</strong></h6><strong>${secondPlanDollars}<sup>{secondPlanCents}</sup></strong> <span>Monthly Cost</span></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Medical Deductible</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>$233</td>
                        <td className='hmo'><h6>CDPHP {result.PlanName} ({result.ShortPlanType}):</h6><strong>${result.MedicalDeductible}</strong></td>
                        <td className='ppo'><h6>CDPHP {secondPlan.PlanName} ({secondPlan.ShortPlanType}):</h6><strong>${secondPlan.MedicalDeductible}</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Prescription Deductible</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Drug Coverage</td>
                        <td className='hmo'><h6>CDPHP {result.PlanName} ({result.ShortPlanType}):</h6><strong>{result.PrescriptionDeductible}</strong></td>
                        <td className='ppo'><h6>CDPHP {secondPlan.PlanName} ({secondPlan.ShortPlanType}):</h6><strong>{secondPlan.PrescriptionDeductible}</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Annual Physicals</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>CDPHP {result.PlanName} ({result.ShortPlanType}):</h6><strong>{result.AnnualPhysicals}</strong></td>
                        <td className='ppo'><h6>CDPHP {secondPlan.PlanName} ({secondPlan.ShortPlanType}):</h6><strong>{secondPlan.AnnualPhysicals}</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Out of Network Coverage</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>CDPHP {result.PlanName} ({result.ShortPlanType}):</h6><strong>{result.OutOfNetworkCoverage}</strong></td>
                        <td className='ppo'><h6>CDPHP {secondPlan.PlanName} ({secondPlan.ShortPlanType}):</h6><strong>{secondPlan.OutOfNetworkCoverage}</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Primary Care Visits</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>20% of Bill</td>
                        <td className='hmo'><h6>CDPHP {result.PlanName} ({result.ShortPlanType}):</h6><strong>{result.PrimaryCareVisits}</strong></td>
                        <td className='ppo'><h6>CDPHP {secondPlan.PlanName} ({secondPlan.ShortPlanType}):</h6><strong>{secondPlan.PrimaryCareVisits}</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Specialist Doctor Visits</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>20% of Bill</td>
                        <td className='hmo'><h6>CDPHP {result.PlanName} ({result.ShortPlanType}):</h6><strong>{result.SpecialistDoctorVisits}</strong></td>
                        <td className='ppo'><h6>CDPHP {secondPlan.PlanName} ({secondPlan.ShortPlanType}):</h6><strong>{secondPlan.SpecialistDoctorVisits}</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Dental Allowance</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>CDPHP {result.PlanName} ({result.ShortPlanType}):</h6><strong>{result.DentalAllowance}</strong></td>
                        <td className='ppo'><h6>CDPHP {secondPlan.PlanName} ({secondPlan.ShortPlanType}):</h6><strong>{secondPlan.DentalAllowance}</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Prescription Drugs</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>CDPHP {result.PlanName} ({result.ShortPlanType}):</h6><Tooltip title='Pricing for prescription drugs is based on a variety of factors, but in general, generic and brand-name drugs that have a proven clinical advantage are typically less expensive, whereas experimental drugs, or those without a proven clinical advantage, tend to be more expensive.' arrow='true'><strong className='helpTip'>{result.PrescriptionDrugs}</strong></Tooltip></td>
                        <td className='ppo'><h6>CDPHP {secondPlan.PlanName} ({secondPlan.ShortPlanType}):</h6><Tooltip title='Pricing for prescription drugs is based on a variety of factors, but in general, generic and brand-name drugs that have a proven clinical advantage are typically less expensive, whereas experimental drugs, or those without a proven clinical advantage, tend to be more expensive.' arrow='true'><strong className='helpTip'>{secondPlan.PrescriptionDrugs}</strong></Tooltip></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Hospital Stays</h5></td>
                        <td className='med'><h6>Original Medicare:</h6><Tooltip title='With Original Medicare, you will have a $1,556 deductible, $389 coinsurance per day from days 61-90, $778/day for each "lifetime reserve day" after day 90 for each benefit period (up to 60 days over your lifetime) for inpatient hospitalizations. CDPHP Medicare plans protect you from potentially high, unexpected costs by instead offering a flat, predictable copay.' arrow='true'><span className='helpTip'>See Details</span></Tooltip></td>
                        <td className='hmo'><h6>CDPHP {result.PlanName} ({result.ShortPlanType}):</h6><strong>{result.HospitalStays}</strong></td>
                        <td className='ppo'><h6>CDPHP {secondPlan.PlanName} ({secondPlan.ShortPlanType}):</h6><strong>{secondPlan.HospitalStays}</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Outpatient Surgeries</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>20% of Bill</td>
                        <td className='hmo'><h6>CDPHP {result.PlanName} ({result.ShortPlanType}):</h6><strong>{result.OutpatientSurgeries}</strong></td>
                        <td className='ppo'><h6>CDPHP {secondPlan.PlanName} ({secondPlan.ShortPlanType}):</h6><strong>{secondPlan.OutpatientSurgeries}</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Urgent Care</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>20% of Bill</td>
                        <td className='hmo'><h6>CDPHP {result.PlanName} ({result.ShortPlanType}):</h6><strong>{result.UrgentCare}</strong></td>
                        <td className='ppo'><h6>CDPHP {secondPlan.PlanName} ({secondPlan.ShortPlanType}):</h6><strong>{secondPlan.UrgentCare}</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Worldwide Emergency Care</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>CDPHP {result.PlanName} ({result.ShortPlanType}):</h6><strong>{result.WorldwideEmergencyCare}</strong></td>
                        <td className='ppo'><h6>CDPHP {secondPlan.PlanName} ({secondPlan.ShortPlanType}):</h6><strong>{secondPlan.WorldwideEmergencyCare}</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Maximum Annual<br />Out-of-Pocket Protection</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Protection</td>
                        <td className='hmo'><h6>CDPHP {result.PlanName} ({result.ShortPlanType}):</h6><strong>{result.MaximumAnnualOutOfPocketProtection}</strong></td>
                        <td className='ppo'><h6>CDPHP {secondPlan.PlanName} ({secondPlan.ShortPlanType}):</h6><strong>{secondPlan.MaximumAnnualOutOfPocketProtection}</strong></td>
                      </tr>
                      {/* <tr>
                        <td className='item'><h5>Centers for Medicare &amp; Medicaid Services Rating<sup>†</sup></h5></td>
                        <td className='med'>N/A</td>
                        <td className='hmo'><img src={medicareRating} alt={result.CmsRating + 'out of 5 Medicare Ranking'} /></td>
                        <td className='ppo'><img src={medicareRating} alt={secondPlan.CmsRating + 'out of 5 Medicare Ranking'} /></td>
                      </tr> */}
                    </tbody></table>
                  <p className='medicare-desc'>*Please note: out-of-network costs shares may differ.</p>
                </div>
              </div>
            </div>
          </section>

          <Element name='learnForm'>
            <LearnMore
              area='MedicareQuoteWesternNY'
              MedicareCompare='true'
              Location={Loc}
              details={fieldValues}
              lastPlanId={s.selectedPlanID}
              phone='585-895-7733 | TTY: 711' />
          </Element>

          <section className='compare-expenses'>
            <div className='wrap sm'>
              <div className='container'>
                <div className='navigate expenses medicare-expenses'>
                  <h4>Looking for other Medicare plan options? </h4>
                  <p><a href='/pdf/CDPHP_2025_Medicare_Rochester_Plan_Options_Brochure.pdf' target='_blank' rel='noopener noreferrer'>Explore all our plans</a> or <a href={'https://cdphpmedicare1.destinationrx.com/PC/2027/Shopping/PlanList?ZipCode=' + Loc.loc.Zip + '&AgentID=cdphpfunnel'} target='_blank' rel='noopener noreferrer'>enroll online</a> if you’re ready.</p>
                </div>
              </div>
            </div>
          </section>

          <ReasonsResults intro="More Reasons Why You'll Love Us" type='medicareWNY' colNum='two' />

          <section id='faq'>
            <div className='wrap sm'>
              <h2>Frequently Asked Questions</h2>
              {accordionData.map(({ index, title, content }) => (
                <Accordion
                  key={index}
                  id={'faq' + index}
                  title={title}
                  content={content} />
              ))}
            </div>
          </section>

          <SendQuote
            area='MedicareSaveQuoteWesternNY'
            MedicareCompare='true'
            Location={Loc}
            details={fieldValues}
            lastPlanId={s.selectedPlanID}
            closeModal={this.closeModal}
            show={this.state.showModal} />

        </article>
      </div>
    );
  }
}

export default ResultsMedicareWesternNY;
